import { NgOptimizedImage } from "@angular/common";
import { Component, Input } from "@angular/core";
import { IconDisplayComponent } from "@ui/ui-helpers/display-formats/icon-display/icon-display.component";
import { NotificationEvent } from "./types";

@Component({
  selector: "lc-notification-item",
  templateUrl: "./notification-item.component.html",
  styleUrl: "./notification-item.component.scss",
  imports: [IconDisplayComponent, NgOptimizedImage],
})
export class NotificationItemComponent {
  @Input() public notification!: NotificationEvent;

  protected get notificationTitle(): string {
    return this.notification.subject;
  }

  protected get notificationBody(): string {
    return this.notification.body;
  }

  protected get notificationDate(): string {
    return this.notification.date;
  }

  protected get hasImage(): boolean {
    return Boolean(this.notification?.image);
  }

  protected get notificationImage(): string {
    return this.notification.image ?? "";
  }

  protected get notificationItemClasses(): string {
    return this.notification?.readed
      ? "notification-item"
      : "notification-item notification-item--unreaded";
  }
}
